import {Selectable} from "../../../../core/interfaces/selectable.interface";

export class Brand implements Selectable<Brand> {
  constructor(
    public readonly id: number,
    public readonly name: string
  ) {
  }

  get value(): this {
    return this;
  }

  get displayName(): string {
    return this.name;
  }

  toSelectText(): string {
    return this.name;
  }

  toSelectDescription(): string {
    return `Wybrana marka: ${this.name}`;
  }
}
